export default "__VITE_ASSET__CdVR8wlv__"